/** @jsxRuntime classic */
/** @jsx jsx */
//@ts-nocheck
import { jsx } from '@emotion/react';
import colors from '../../OrderEntry/css/colors';

const tooTipWrap = {
  position: 'relative',
  // verticalAlign: 'top',
  // '&:hover': {
  //   ' > div': {
  //     opacity: 1,
  //     transition: 'all 0s ease 1s',
  //   },
  // },     
};

const toolTip = {
  alignItems: 'center',
  backgroundColor: colors.black,
  borderRadius: '5px',
  color: colors.white,
  justifyContent: 'center',
  position: 'absolute',
  bottom: 30,
  //opacity: 0,
  width: 'auto',       
  whiteSpace: 'nowrap',
  padding: 16,
  zIndex:500,
  ' span': {
    borderColor: '#33322F transparent transparent transparent',
    borderStyle: 'solid',
    borderWidth: '6px 6px 0 6px',
    height: 0,
    position: 'absolute',
    bottom: -6,
    width: 0,
  },
};

const NotificationToolTip = ({
  notifications
}) => {
  return (
    <div css={tooTipWrap}>
      <div css={toolTip}>
        <div style={{color:'#8E8E93', paddingBottom:16}}>Notifications: </div>
        {notifications.map((n) => {
            return (
                <div style={{listStyle: 'inside', paddingBottom:8}}>{n?.label}</div>
            )
        })}
        <span />
      </div>
    </div>
  );
};

export default NotificationToolTip;
